import React from 'react';
import { Text, Switch, View } from 'react-native';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { enUS } from './en-US.js';
import { zhHK } from './zh-HK.js';
import { languageStorage } from './../../lib/LanguageStorage';
import { TrendingUpSharp } from '@material-ui/icons';

export default class YesNoQuestion extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      text: {},
    };
  }

  _onChange(choice) {
    this.props.onChange(choice);
  }

  componentDidMount() {
    const getText = (language) => {
      let text = enUS;
      if (language == 'zhHK') {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage(
      (language) => this.setState({text: getText(language)}));
  }

  render() {
    const yesText = this.props.yesLabel || this.state.text?.yes
    const noText = this.props.noLabel || this.state.text?.no
    return (
      <div>
       <View style={{textAlign: 'Center'}}>
        <Text style={this.props.questionStyle}>{this.props.question}</Text>
       </View>
        <FormControl style={styles.formControl}>
              {
                this.props.reverse ?
                  <Button
                   variant="contained"
                    style={{marginLeft:20,textTransform: 'none'}}
                    color={this.props.choice == 'N' ? 'primary' : null}
                    onClick={(value) => this._onChange(value ? 'N' : null)}
                  >{yesText}</Button> :
                  <Button
                    variant="contained"
                    style={{marginRight:20,textTransform: 'none'}}
                    color={this.props.choice == 'Y' ? 'primary' : null}
                    onClick={(value) => this._onChange(value ? 'Y' : null)}
                  >{yesText}</Button>
              }

              {
                this.props.reverse ?
                  <Button
                   variant="contained"
                    style={{textTransform: 'none'}}
                    color={this.props.choice == 'Y' ? 'primary' : null}
                    onClick={(value) => this._onChange(value ? 'Y' : null)}
                  >{noText}</Button> :
                  <Button
                   variant="contained"
                    style={{textTransform: 'none'}}
                    color={this.props.choice == 'N' ? 'primary' : null}
                    onClick={(value) => this._onChange(value ? 'N' : null)}
                  >{noText}</Button>
              }
            </FormControl>


      </div>
    );
  }
}

const styles = {
  yesNoQuestion: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 10,
  },

  formControl: {
    display: 'block',
    marginTop: 12,
    marginBottom: 12,
  },
};
